/* MPC campaign: live countdown (<mpc-campaign-timer>) and the offer info box (<mpc-campaign-info>).
   Custom elements, so they also work inside the cart drawer, which is re-rendered after every cart change.
   When a countdown reaches zero every [data-mpc-campaign] element is hidden, matching the server-side end time. */
(function () {
  'use strict';
  if (window.__mpcCampaign) return;
  window.__mpcCampaign = true;

  function endCampaign() {
    document.querySelectorAll('[data-mpc-campaign]').forEach(function (el) { el.hidden = true; });
    document.documentElement.classList.add('mpc-campaign-ended');
  }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  var timers = new Set(), tick = null;
  function render(el) {
    var left = Math.floor(+el.dataset.end - Date.now() / 1000);
    if (left <= 0) { endCampaign(); return false; }
    var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), s = left % 60;
    el.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
    return true;
  }
  function loop() {
    timers.forEach(function (el) { if (!el.isConnected || !render(el)) timers.delete(el); });
    if (!timers.size && tick) { clearInterval(tick); tick = null; }
  }

  customElements.define('mpc-campaign-timer', class extends HTMLElement {
    connectedCallback() {
      if (!render(this)) return;
      timers.add(this);
      if (!tick) tick = setInterval(loop, 1000);
    }
    disconnectedCallback() { timers.delete(this); }
  });

  customElements.define('mpc-campaign-info', class extends HTMLElement {
    connectedCallback() {
      var btn = this.querySelector('[data-info-btn]'), panel = this.querySelector('[data-info-panel]');
      if (!btn || !panel) return;
      var pinned = false, t = null, self = this;
      var hoverable = window.matchMedia('(hover: hover) and (min-width: 750px)').matches;
      function set(open) { panel.hidden = !open; btn.setAttribute('aria-expanded', String(open)); }
      btn.addEventListener('click', function (e) { e.stopPropagation(); pinned = panel.hidden; set(pinned); });
      if (hoverable) {
        this.addEventListener('mouseenter', function () { clearTimeout(t); set(true); });
        this.addEventListener('mouseleave', function () { clearTimeout(t); t = setTimeout(function () { if (!pinned) set(false); }, 180); });
      }
      this._out = function (e) { if (!self.contains(e.target)) { pinned = false; set(false); } };
      this._esc = function (e) { if (e.key === 'Escape') { pinned = false; set(false); } };
      document.addEventListener('click', this._out);
      document.addEventListener('keydown', this._esc);
      panel.addEventListener('click', function (e) {
        var b = e.target.closest('[data-copy]');
        if (!b) return;
        var done = function () { var o = b.textContent; b.textContent = 'Copied'; setTimeout(function () { b.textContent = o; }, 1400); };
        if (navigator.clipboard) navigator.clipboard.writeText(b.dataset.copy).then(done, done); else done();
      });
    }
    disconnectedCallback() {
      document.removeEventListener('click', this._out);
      document.removeEventListener('keydown', this._esc);
    }
  });

  // A page that was already open when the campaign ended (covers badges, which have no timer)
  var stop = window.mpcCampaignEnd;
  if (stop) {
    var ms = stop * 1000 - Date.now();
    if (ms <= 0) endCampaign();
    else if (ms < 2147483647) setTimeout(endCampaign, ms);
  }
})();
